import { Injectable } from '@angular/core';

export type Brand = 'tpro' | 'speechwrite';

@Injectable({ providedIn: 'root' })
export class BrandingService {
  readonly brand: Brand = this.resolveBrand();

  get isSpeechwrite(): boolean {
    return this.brand === 'speechwrite';
  }

  /** Full logo lockup used on the login page, first-login flow and the expanded nav. */
  get logoSrc(): string {
    return this.isSpeechwrite ? 'assets/scribe_full.svg' : 'assets/logo.svg';
  }

  /** Registered mat-icon name used for the collapsed nav. */
  get logoCompactIcon(): string {
    return this.isSpeechwrite ? 'speechwrite-icon' : 'logo-compact';
  }

  /** The gradient "Scribe" wordmark is only shown for T-Pro; the SpeechWrite lockup already includes it. */
  get showScribeWordmark(): boolean {
    return !this.isSpeechwrite;
  }

  /** Partner builds show a "powered by T-Pro" line in white. */
  get showPoweredByTpro(): boolean {
    return this.isSpeechwrite;
  }

  private resolveBrand(): Brand {
    // The domain is the source of truth: a SpeechWrite host always renders the
    // SpeechWrite brand, even when a runtime config defaults brand to 'tpro'.
    // SpeechWrite is served from both speechwrite.* and sw360-* (tpro.rocks) hosts.
    const hostname = typeof window !== 'undefined' ? window.location?.hostname ?? '' : '';
    if (/speechwrite|sw360/i.test(hostname)) return 'speechwrite';

    // Otherwise honour an explicit runtime override. Read runtimeConfig via a
    // local cast: the Window augmentation lives in environment.custom.ts, which
    // is not part of every build configuration.
    const runtimeConfig = (window as unknown as { runtimeConfig?: { brand?: Brand } }).runtimeConfig;
    const fromConfig = runtimeConfig?.brand;
    if (fromConfig === 'speechwrite' || fromConfig === 'tpro') return fromConfig;

    return 'tpro';
  }
}
